import DialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import {Dialog, Grid, Chip, TextField} from '@material-ui/core';

//@ts-ignore
import CancelButton from "hcla-web-frontend-primitives/app/components/primitives/Buttons/CancelButton";
//@ts-ignore
import CreateButton from "hcla-web-frontend-primitives/app/components/primitives/Buttons/CreateButton";

import HCLTreeVertex from '../../../../../mxGraph/HCLTreeNode/HCLTreeVertex';
import Typography from "@material-ui/core/Typography";
import {DialogProps} from "@material-ui/core/Dialog";
import FullScreenDialog from "../../../../Primitives/FullScreenDialog";
import InputRules from "../Inputs/InputRules";

interface Props extends DialogProps {
  vertex: HCLTreeVertex;
  onClose: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  onSave: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  error?: boolean;
}

interface State {
  nodeIdHasError: boolean;
}

class VertexSelectionDialog extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.state = {
      nodeIdHasError: !InputRules.isNodeIdValid(props.vertex.getKey())
    }
  }

  private handleSave = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    const { vertex, onSave, onClose } = this.props;
    onSave(e);
    vertex.getGraph().getView().refresh();
    onClose(e);
  };

  render() {
    const { vertex, onClose, children, error, ...others } = this.props;
    const { nodeIdHasError } = this.state;
    return (
      <FullScreenDialog {...others}>
        <DialogTitle>
          <Grid
            container
            alignItems="center"
            justify="space-between"
          >
            <Grid item>
              <Typography
                variant="h6"
                color="textPrimary"
              >
                {vertex.getType()}
              </Typography>
            </Grid>
            <Grid item>
              <TextField
                defaultValue={vertex.getKey()}
                onChange={e => {
                  const value = e.target.value;
                  const nodeIdHasError = !InputRules.isNodeIdValid(value);
                  this.setState({ nodeIdHasError })
                  vertex.setKey(value)
                }}
                variant="outlined"
                color="secondary"
                error={nodeIdHasError}
                helperText={nodeIdHasError ? InputRules.DESCRIPTIONS.NODE_ID : undefined}
              />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            spacing={8}
            justify="space-evenly"
            alignItems="flex-end"
          >
            {children}
          </Grid>
        </DialogContent>
        <DialogActions>
          <CancelButton
            variant="outlined"
            size="large"
            onClick={onClose}
          >
            Cancel
          </CancelButton>
          <CreateButton
            onClick={this.handleSave}
            disabled={error || nodeIdHasError}
            variant="outlined"
            size="large"
          >
            Save
          </CreateButton>
        </DialogActions>
      </FullScreenDialog>
    );
  }
}

export default VertexSelectionDialog;
